<div class="processing">
  <div class="processing__column">
    <gen-info-box class="processing__error" [iconType]="'error'" [message]="processingErrorMessage" *ngIf="isProcessingFailed()"
                  [textTitle]="'Server processing failure'" [borderCss]="'__border'"
    ></gen-info-box>
    <gen-info-lines [sourceData]="diagnosticOrder" [translationPrefix]="'processing'"
                    [fieldsToDisplay]="pcrRunFields" [title]="pcrRunTitle">
    </gen-info-lines>
    <gen-info-box class="processing__warning" [iconType]="'info'" [message]="thermalWarningMessage" *ngIf="thermalWarning" [borderCss]="'__border'"></gen-info-box>
  </div>
  <div class="processing__column">
    <gen-info-lines [sourceData]="diagnosticOrder" [translationPrefix]="'processing'"
                    [fieldsToDisplay]="sampleFields" [title]="sampleTitle">
    </gen-info-lines>
  </div>
</div>
